export default () => [
  {
    type: 'checkbox',
    width: 40,
    align: 'center',
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    width: 90,
    slots: {
      default: 'opt',
    },
  },
  {
    type: 'expand',
    width: 60,
    align: 'center',
    title: '展开',
    slots: {
      content: 'expandContent',
    },
  },
  {
    field: 'originPointName',
    align: 'center',
    minWidth: 150,
    title: '发货方名称',
  },
  {
    field: 'origin',
    align: 'center',
    minWidth: 150,
    title: '始发地',
  },
  {
    field: 'destPointName',
    align: 'center',
    minWidth: 150,
    title: '收货方名称',
  },
  {
    field: 'dest',
    align: 'center',
    minWidth: 150,
    title: '目的地',
  },
  {
    field: 'linePriceTypeText',
    align: 'center',
    width: 120,
    title: '报价方式',
  },
  {
    field: 'lineMinPrice',
    align: 'center',
    width: 100,
    title: '最低收费',
  },
  {
    field: 'isBackName',
    align: 'center',
    width: 100,
    title: '是否返程',
  },
  {
    field: 'lineTime',
    align: 'center',
    width: 100,
    title: '时效',
  },
  {
    field: 'orderTypeName',
    align: 'center',
    width: 100,
    title: '订单类型',
  },
  {
    field: 'bizTypeName',
    align: 'center',
    width: 100,
    title: '业务类型',
  },
  {
    field: 'goodsTypeName',
    align: 'center',
    width: 100,
    title: '货物类型',
  },
]
